import React from 'react'
import { useEngagementDetailOverlay } from '@/organisms/CollectibleSceneInfo/EngagementDetailOverlay'
import { MomentOwner, MomentOwnerStory } from '@/services/MomentsService/types'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { getUserDisplayName } from '@/utils/users'
import { MomentOwnershipAvatar, StoryType } from '../MomentOwnershipAvatar'

interface OwnershipAvatarsProps {
  projectName?: string
  actors: MomentOwner[]
  owners: MomentOwner[]
}

const getStoryType = (story?: MomentOwnerStory): StoryType => {
  let storyType

  if (story?.text) {
    storyType = 'text'
  } else if (story?.videoUri) {
    storyType = 'video'
  }

  return storyType as StoryType
}

export const OwnershipAvatars: React.FC<OwnershipAvatarsProps> = ({ actors, owners, projectName }) => {
  const { onOpen } = useEngagementDetailOverlay()

  const combinedOwnership: (MomentOwner & { isActor: boolean })[] = [
    ...(actors?.map((actor) => ({ ...actor, isActor: true })) || []),
    ...(owners?.map((owner) => ({ ...owner, isActor: false })) || []),
  ]

  return (
    <>
      {combinedOwnership?.map((owner, index) => {
        return (
          <MomentOwnershipAvatar
            index={index}
            iconPosition="left"
            key={owner?.id}
            isActor={owner?.isActor}
            onClick={
              owner?.isActor && getStoryType(owner?.story)
                ? () => {
                    onOpen({
                      id: owner.story?.id || null || undefined,
                      userId: owner?.id as string,
                      isFromActor: true,
                      projectName,
                      text: owner?.story?.text,
                      videoUri: owner?.story?.videoUri,
                      userName: getUserDisplayName(owner),
                      userAvatar: owner?.profile?.image,
                      publishDate: owner?.story?.publishDate,
                      totalLikes: owner?.story?.totalLikes,
                      isLikedByUser: owner?.story?.isLikedByUser,
                      momentId: owner?.story?.momentId,
                    })
                  }
                : undefined
            }
            name={getUserDisplayName(owner)}
            storyType={getStoryType(owner?.story)}
            imageUrl={
              owner?.profile?.image ||
              getCloudinaryImageUrl({ path: '/v1682448343/angel-studios/avatar-square', height: 48, width: 48 })
            }
          />
        )
      })}
    </>
  )
}
